import { render } from "./Announcement.vue?vue&type=template&id=75376ff7&scoped=true&lang=pug"
import script from "./Announcement.vue?vue&type=script&lang=ts"
export * from "./Announcement.vue?vue&type=script&lang=ts"

import "./Announcement.vue?vue&type=style&index=0&id=75376ff7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-75376ff7"

export default script